import { useRouter } from "next/router";
import Head from "next/head";
import Image from "next/image";
import style from "./Error500.module.scss";
import { Button } from "../Button";
import { clearAllCookies, Storage } from "@/helper/helper";
const Error500 = () => {
  const router = useRouter();
  const handleLogOut = () => {
    Storage().clearStorage();
    clearAllCookies();
    router.replace("/");
  };
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="Error500.tsx">
        <title>500</title>
      </Head>
      <div className={style.wrapper}>
        <div className={style.box}>
          <h1 className={style.title}>Sorry, unexpected error</h1>
          <p className={style.des}>
            We are trying to fix the issue at the moment. Please come back soon.
          </p>
          <Image src={"/common/500-error.svg"} alt="Sorry, unexpected error" width={497} height={434} data-sentry-element="Image" data-sentry-source-file="Error500.tsx" />
          <div className={style.buttonWrapper}>
            <Button title={"Home"} variant="outline_primary" className={style.btn} onClick={() => router.push("/")} data-sentry-element="Button" data-sentry-source-file="Error500.tsx" />
            <Button title={"Logout"} variant="outline_primary" className={style.btn} onClick={handleLogOut} data-sentry-element="Button" data-sentry-source-file="Error500.tsx" />
            <Button title={"Refresh"} className={style.btn} onClick={router.reload} data-sentry-element="Button" data-sentry-source-file="Error500.tsx" />
          </div>
        </div>
      </div>
    </>;
};
export default Error500;